import { Rule } from 'antd/lib/form';
import React, { useMemo } from 'react';
import { TFirmwareType } from 'types';
import { firmwareTypes } from 'appConstants';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { useTranslation } from 'react-i18next';

interface IFirmwareTypeSelect {
	setTypeSelectedFirmware: (value: TFirmwareType) => void;
}

const FirmwareTypeSelect: React.FC<IFirmwareTypeSelect> = ({ setTypeSelectedFirmware }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectFirmwareType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return firmwareTypes.map((el) => ({ id: el.firmwareTypeID, name: el.firmwareTypeName }));
	}, [firmwareTypes]);

	return (
		<FormSelect
			testId="FirmwareTypeSelect"
			name="typeSelectedFirmware"
			label="firmwareTypeLabel"
			disabled={true}
			options={mappedOptions}
			onChange={setTypeSelectedFirmware}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(FirmwareTypeSelect);
